import jwtAuthAxios from "services/jwtAuth";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

export const getById = createAsyncThunk("beasiswa/getById",
	async(val) => {
		try{
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const url = `v1/cfg/beasiswa/${val}`
			const response = await jwtAuthAxios.get(url)
			return response.data;
		} catch(response){
			throw response
		}
	});


export const findAll = createAsyncThunk("beasiswa/findAll",
	async(val) => {
		try{
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const url = `v1/cfg/beasiswa`
			const response = await jwtAuthAxios.get(url)
			return response.data;
		} catch(response){
			throw response
		}
	});

export const save = createAsyncThunk("beasiswa/save",
	async(val) => {
		try{
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const url = `v1/cfg/beasiswa`
			const response = await jwtAuthAxios.post(url,val)
			return response.data;
		} catch(response){
			throw response
		}
	});


export const update = createAsyncThunk("beasiswa/update",
	async(val) => {
		try{
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const url = `v1/cfg/beasiswa`
			const response = await jwtAuthAxios.put(url,val);
			return response.data;
		} catch(response){
			throw response
		}
	});

export const remove = createAsyncThunk("beasiswa/remove",
	async(val) => {
		try{
			let token = await localStorage.getItem('auth_token');
			jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
			const url = `v1/cfg/beasiswa/${val}`
			const response = await jwtAuthAxios.delete(url);
			return response.data;
		} catch(response){
			throw response
		}
	});


const initialState = {
	loading: false,
	dataBeasiswa : {},
	beasiswaList: [],
}

const beasiswaSlice = createSlice({
	name:"beasiswaSlice",
	initialState: initialState,
	extraReducers: (builder) => {
		builder
			.addCase(getById.pending, (state) => {
				state.loading = true;
			})
			.addCase(getById.fulfilled, (state, action) => {
				state.dataBeasiswa = action.payload;
				state.loading = false;
			})
			.addCase(getById.rejected, (state, action) => {
				state.loading = false;
			})
		builder
			.addCase(findAll.pending, (state) => {
				state.loading = true;
			})
			.addCase(findAll.fulfilled, (state, action) => {
				state.beasiswaList = action.payload;
				state.loading = false;
			})
			.addCase(findAll.rejected, (state, action) => {
				state.loading = false;
			})
		builder
			.addCase(save.pending, (state) => {
				state.loading = true;
			})
			.addCase(save.fulfilled, (state, action) => {
				state.dataBeasiswa = action.payload;
				state.loading = false;
			})
			.addCase(save.rejected, (state, action) => {
				state.loading = false;
			})
		builder
			.addCase(update.pending, (state) => {
				state.loading = true;
			})
			.addCase(update.fulfilled, (state, action) => {
				state.dataBeasiswa = action.payload;
				state.loading = false;
			})
			.addCase(update.rejected, (state, action) => {
				state.loading = false;
			})
		
		builder
			.addCase(remove.pending, (state) => {
				state.loading = true;
			})
			.addCase(remove.fulfilled, (state, action) => {
				state.dataBeasiswa = action.payload;
				state.loading = false;
			})
			.addCase(remove.rejected, (state, action) => {
				state.loading = false;
			})
	}
})
export const beasiswaSelector = (state) => state.beasiswa;
export default beasiswaSlice.reducer;
